import { useCallback, useState } from "react";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../externalComponents/tailwind/dialog";

export function BlockContactDialog({
  modalRef,
  setModalRef,
  conversationId,
  whatsappName,
  getNextConversation,
}) {
  const closeModal = useCallback(
    () => setModalRef((_modalRef) => ({ ..._modalRef, blockContact: false })),
    [setModalRef],
  );
  const [blockingLoading, setBlockingLoading] = useState(false);

  return (
    <Dialog open={modalRef.blockContact} onClose={closeModal}>
      <DialogTitle>{`Block ${whatsappName ?? "this contact"}`}</DialogTitle>
      <DialogBody>
        By blocking this contact, he/she will no longer appear in your inbox.
        However, he/she will still be able to send you messages as the WhatsApp
        api does not allow you to block a contact permanently.
      </DialogBody>
      <DialogActions>
        <Button color="secondaryButton" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          color="primaryButton"
          loading={blockingLoading}
          onClick={async () => {
            setBlockingLoading(true);
            await api.conversation.update(conversationId, {
              isArchived: true,
            });
            setBlockingLoading(false);
            closeModal();
            getNextConversation();
          }}
        >
          Block
        </Button>
      </DialogActions>
    </Dialog>
  );
}
